module.exports = __webpack_public_path__ + "img/dripicons-v2.0253a9a5.svg";